"use client";

import {VisitorsReportTableCard} from "./report-topbar/visitorsReportCard";

type ReportTableCardRendererProps = {
  reportdata: any;
};

export const ReportTableCardRenderer: React.FC<
  ReportTableCardRendererProps
> = ({reportdata}) => {
  const tableCardView = reportdata?.activeReport?.tableCardView;

  switch (tableCardView) {
    case "visitorsReport":
      return <VisitorsReportTableCard reportdata={reportdata} />;
    default:
      return <VisitorsReportTableCard reportdata={reportdata} />;
  }
};
